import { makeAutoObservable } from "mobx";

export enum DIALOG_TYPE {
  NONE = 0,
  TERMS = 1,
  SELECT_WALLET = 2,
  ASSETS = 3,
  DEPOSIT = 4,
  WITHDRAW = 5,
  TRANSFER = 6,
  START_TRADING = 7,
  TRADEBOX = 8,
  WHITELIST_DENIED = 9,
}

export class DialogStore {
  // ==================== STATE ====================
  openDialogs: Set<DIALOG_TYPE> = new Set();
  transferFromAccount: string | null = null;
  tradeboxInitialDirection: "long" | "short" = "long";

  constructor() {
    makeAutoObservable(this);
  }

  // ==================== ACTIONS ====================
  open = (dialog: DIALOG_TYPE, params?: { transferFrom?: string; direction?: "long" | "short" }) => {
    this.openDialogs.add(dialog);
    if (dialog === DIALOG_TYPE.TRANSFER && params?.transferFrom) {
      this.transferFromAccount = params.transferFrom;
    }
    if (dialog === DIALOG_TYPE.TRADEBOX && params?.direction) {
      this.tradeboxInitialDirection = params.direction;
    }
  };

  close = (dialog: DIALOG_TYPE) => {
    this.openDialogs.delete(dialog);
    if (dialog === DIALOG_TYPE.TRANSFER) {
      this.transferFromAccount = null;
    }
    if (dialog === DIALOG_TYPE.TRADEBOX) {
      this.tradeboxInitialDirection = "long";
    }
  };

  closeAll = () => {
    this.openDialogs.clear();
    this.transferFromAccount = null;
    this.tradeboxInitialDirection = "long";
  };

  // ==================== GETTERS ====================
  isVisible = (type: DIALOG_TYPE) => {
    return this.openDialogs.has(type);
  };
}
